/** ----------------------------------------
     Module Interface
 ---------------------------------------- */

import module from './interface';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {

    /** ----------------------------------------
        Menu
     ---------------------------------------- */

    getInit: state => {
        return state.data.init;
    },

    /** ----------------------------------------
         Menu
     ---------------------------------------- */

    getMenu: state => {
        return state.data.menu;
    },

    /** ----------------------------------------
         Contact
     ---------------------------------------- */

    getContactInformation: state => type => {
        return state.data.contact[type];
    },

    /** ----------------------------------------
        Logo's
     ---------------------------------------- */

    getLogos: state => {
        return state.data.logos;
    },

    /** ----------------------------------------
         Translations
     ---------------------------------------- */

    getTranslation: state => {
        return state.data.names;
    },

    /** ----------------------------------------
         Language
     ---------------------------------------- */

    getLanguage: state => {
        return state.data.lang;
    }

};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters